import { createAction, props } from '@ngrx/store';

export const SET_TOKEN = '[AUTH] SET_TOKEN';

export const setTokenAction = createAction(SET_TOKEN, props<{ payload: { token: string | null | undefined } }>());
